import React, { useState, useContext, useEffect } from 'react'
import { StyleSheet, Text, View, Image, ActivityIndicator } from 'react-native';
import { MdClose } from "react-icons/md";
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { blackColor, fontColorWhite } from '../../../../../style/css/CmnStyle';
import { hpContext } from '../../../HPContext';


function HpContentOpenApp(props) {
  const { t } = useTranslation();
  const isWide = useContext(hpContext).isWide;

  const isOpenApp = props.isOpenApp;
  const [isOpenModal, setIsOpenModal] = useState(false);

  const windowDimensions = useContext(hpContext).windowDimensions;
  const windowWidth = windowDimensions.width;

  const [modalWidth, setModalWidth] = useState(0);
  const [closeSize, setCloseSize] = useState(0);
  const [logoSize, setLogoSize] = useState(0);

  // 現在表示しているパス
  const location = useLocation();
  const [link, setLink] = useState(null);
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isAndroid = /Android/i.test(navigator.userAgent);


  useEffect(() => {
    if(isOpenApp) {
      const path = location.pathname.replace(/^\//, ''); // スラッシュ削除
      const full = path + location.search;

      if(isIOS) {
        setLink(`${process.env.REACT_APP_CUSTOM_LINK}://${full}`);
        setIsOpenModal(true);
      } else if(isAndroid) {
        setLink(`intent://${full}#Intent;scheme=${process.env.REACT_APP_CUSTOM_LINK};package=${process.env.REACT_APP_ID};end`);
        setIsOpenModal(true);
      } else {
        setIsOpenModal(false);
      }
    } else {
      setIsOpenModal(false);
    }
  }, [isOpenApp, isIOS, isAndroid])


  useState(() => {
    // モーダル幅
    setModalWidth(isWide
      ? windowWidth * 0.4
      : windowWidth * 0.7
    );
    // 閉じるボタン
    setCloseSize(isWide
      ? windowWidth * 0.03
      : windowWidth * 0.13
    );
    // ロゴ
    setLogoSize(isWide
      ? windowWidth * 0.035
      : windowWidth * 0.15
    );
  }, [isWide]);

  const onClose = () => {
    setIsOpenModal(false);
  }


  return (
    <>
    {isOpenModal &&
      <div style={styles.overlay}>
        <div style={{...styles.modal, width: modalWidth}}>

          <MdClose
            style={{
              ...styles.close,
              width: closeSize, height: closeSize,
              top: -closeSize,
              right: 5,
            }}
            onClick={onClose}
          />


          <View style={styles.titleWrap}>
            <Image
              defaultSource={'./assets/img/logo.png'}
              style={{
                ...styles.logo,
                width: logoSize,
                height: logoSize,
              }}
            />
            <Text style={{
              ...styles.title,
              fontSize: isWide? '2.5em' : '2em',
            }}>Skaters</Text>
          </View>

          {link ?
            <View
              style={{
                ...styles.btn,
                width: isWide? '70%' : '100%',
              }}
              onClick={() => {
                window.location.href = link;
              }}
            >
              {/* アプリを開く */}
              <Text
                style={{
                  ...styles.btnTxt,
                  fontSize: isWide? '1.3em' : '1.2em',
                }}
              >{t('app.openBtn')}</Text>
            </View>
          :
            <ActivityIndicator
              color={blackColor}
              size={'large'}
            />
          }

        </div>
      </div>
    }
    </>
  );
}

const styles = StyleSheet.create({
  overlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  },
  modal: {
    position: 'relative',
    backgroundColor: fontColorWhite,
    padding: '2rem',
    borderRadius: '8px',
  },

  close: {
    position: 'absolute',
    color: fontColorWhite,
  },

  titleWrap: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logo: {
    borderRadius: 10,
  },
  title: {
    color: blackColor,
    fontWeight: 'bold',
    marginLeft: 10,
  },

  btn: {
    backgroundColor: blackColor,
    marginTop: 30,
    paddingVertical: 10,
    borderRadius: 10,
    marginHorizontal: 'auto',
  },
  btnTxt: {
    color: fontColorWhite,
    fontWeight: 'bold',
    textAlign: 'center',
  },
});

export default HpContentOpenApp;
